<h2 mat-dialog-title>{{ 'EMAIL_TEMPLATES.PREVIEW.SEND_TEST_EMAIL.TITLE' | translate }}</h2>

<mat-dialog-content>
  <div>
    @if (senderInfo) {
      <p>
        {{ 'EMAIL_TEMPLATES.PREVIEW.SEND_TEST_EMAIL.SENT_FROM_1' | translate }}
        <span class="display-name">{{ senderInfo.senderEmail }}</span>
        {{ 'EMAIL_TEMPLATES.PREVIEW.SEND_TEST_EMAIL.SENT_FROM_2' | translate }}
      </p>
    }
    <div>
      {{ 'EMAIL_TEMPLATES.PREVIEW.PREVIEWING_AS' | translate }}
      @if (data.contact) {
        <span class="display-name">
          @if (data.contact?.name) {
            <span>{{ data.contact.name }}</span>
          }
          @if (data.contact?.email) {
            <span> ({{ data.contact.email }})</span>
          }
        </span>
      } @else if (data.business) {
        <span class="display-name">
          {{ data.business.name }}
        </span>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close="">
    {{ 'EMAIL_TEMPLATES.PREVIEW.SEND_TEST_EMAIL.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="sendPreviewEmail()">
    <glxy-button-loading-indicator [isLoading]="loading()">
      {{ 'EMAIL_TEMPLATES.PREVIEW.SEND_TEST_EMAIL.SEND' | translate }}
    </glxy-button-loading-indicator>
  </button>
</mat-dialog-actions>
